import { render, staticRenderFns } from "./DarkLogo.vue?vue&type=template&id=5d035a07&"
import script from "./DarkLogo.vue?vue&type=script&lang=js&"
export * from "./DarkLogo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports